import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { Time } from "@@/shared/date-time/time";
import type { EntityState } from "@@/shared/entity-status";
import type { OrderId } from "@@/shared/orders/order-id";
import type { Price } from "@@/shared/prices/price";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import type { HomeDeliveryDestination } from "../home-deliveries/home-delivery-destination";
import type { HomeDeliveryOrigin } from "../home-deliveries/home-delivery-origin";
import type { ShippingId } from "../shipping/shipping-id";
import type { ShipmentId } from "./shipment-id";
import type { ShipmentPackage } from "./shipment-package";

type ShipmentOrder = {
    readonly _id: ShipmentId;
    readonly _type: "SHIPMENT";
    readonly _status: EntityState;
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly shipmentType: "SHIPMENT_ORDER";
    readonly orderId: OrderId;
    readonly orderGroupReference: string;

    /**
     *
     * Human readable kolli
     * @type {string}
     */
    readonly shipmentReference: string;
    readonly shippingId: ShippingId;
    readonly pickup: IsoAndUnixTimestamp;
    readonly slot: Time | undefined;
    readonly packages: ShipmentPackage[];

    readonly origin: HomeDeliveryOrigin; //Pickup or Origion
    readonly destination: HomeDeliveryDestination; //Desitnation
    readonly price: Price;
};

const shipmentOrderFactory = (
    params: Except<ShipmentOrder, "_id" | "_type" | "_status" | "_createdAt">,
): ShipmentOrder => {
    return {
        ...params,
        _id: generateId({ prefix: "shipment__" }),
        _type: "SHIPMENT",
        _status: "ACTIVE",
        _createdAt: nowIsoAndUnix(),
        shipmentType: "SHIPMENT_ORDER",
    };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isShipmentOrder = (s: any): s is ShipmentOrder => {
    return (
        s.shipmentType === "SHIPMENT_ORDER" ||
        s.shipmentType === null ||
        s.shipmentType === undefined
    );
};

export { isShipmentOrder, shipmentOrderFactory };
export type { ShipmentOrder };
